// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  enableDebug: true,

  numero_WhatsApp: "+393922360549",
  numero_telefono: "tel:+393922360549",

  //text per personalizzare i messaggi
  canShowPagamentoRate: false,
  textShowPagamentoRate: "in comode <strong>2 rate</strong>",

  canShowElencoDate: true,

  /*
  urlWeb: 'http://localhost/',
  urlMaterialeDidattico: 'http://localhost/assets/media/materiale-didattico/1/',
  urlImageCorso: 'http://localhost/assets/media/corso/',
  urlImageCorsoHD: 'http://localhost/assets/media/corso/hd/',
  urlImageVideoCorso: 'http://localhost/assets/media/corso/video/',
  web_api_url_base: 'http://localhost/api/',

  urlStampa: 'http://localhost/stampe/',

  urlAttestati: 'http://localhost/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'http://localhost/pages/certificate/',
  urlImagePartners: 'http://localhost/assets/media/partners/',
  urlImageMedia: 'http://localhost/assets/media/',
  */

  urlWeb: 'https://ilsaperecentrostudi.discentya.it/',
  urlMaterialeDidattico: 'https://ilsaperecentrostudi.discentya.it/assets/media/materiale-didattico/1/',
  urlImageCorso: 'https://ilsaperecentrostudi.discentya.it/assets/media/corso/',
  urlImageCorsoHD: 'https://ilsaperecentrostudi.discentya.it/assets/media/corso/hd/',
  urlImageVideoCorso: 'https://ilsaperecentrostudi.discentya.it/assets/media/corso/video/',
  web_api_url_base: 'https://ilsaperecentrostudi.discentya.it/api/',

  urlStampa: 'https://ilsaperecentrostudi.discentya.it/stampe/',

  urlAttestati: 'https://ilsaperecentrostudi.discentya.it/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'https://ilsaperecentrostudi.discentya.it/pages/certificate/',
  urlImagePartners: 'https://ilsaperecentrostudi.discentya.it/assets/media/partners/',
  urlImageMedia: 'http://ilsaperecentrostudi.discentya.it/assets/media/',

};

